(()=>{
  const phone=matchMedia('(max-width:650px)'),menu=document.querySelector('.mobile-nav');
  document.addEventListener('click',event=>{if(menu?.open&&!menu.contains(event.target))menu.open=false;});
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&menu?.open){menu.open=false;menu.querySelector('summary').focus();}});
  function syncFieldFocus(){
    const active=document.activeElement;
    const editing=active?.matches('textarea,input:not([type=checkbox]):not([type=radio]):not([type=hidden]):not([type=submit]):not([type=button])');
    document.documentElement.classList.toggle('mobile-field-focus',phone.matches&&Boolean(editing));
  }
  document.addEventListener('focusin',syncFieldFocus);
  document.addEventListener('focusout',()=>requestAnimationFrame(syncFieldFocus));
  phone.addEventListener('change',syncFieldFocus);
  const gallery=document.querySelector('.main-image');
  if(!gallery)return;
  gallery.querySelector('img')?.setAttribute('draggable','false');
  let start=null;
  gallery.addEventListener('pointerdown',event=>{
    if(!phone.matches||event.button!==0||event.target.closest('button'))return;
    start={x:event.clientX,y:event.clientY,id:event.pointerId};
  });
  gallery.addEventListener('pointercancel',()=>{start=null;});
  gallery.addEventListener('pointerup',event=>{
    if(!start||start.id!==event.pointerId)return;
    const dx=event.clientX-start.x,dy=event.clientY-start.y;start=null;
    if(Math.abs(dx)<45||Math.abs(dx)<Math.abs(dy)*1.5)return;
    gallery.querySelector(dx<0?'[data-photo-next]':'[data-photo-prev]')?.click();
  });
})();
